import { render, staticRenderFns } from "./ForTrainer.vue?vue&type=template&id=5e2c2a46&scoped=true&"
import script from "./ForTrainer.vue?vue&type=script&lang=js&"
export * from "./ForTrainer.vue?vue&type=script&lang=js&"
import style0 from "./ForTrainer.vue?vue&type=style&index=0&id=5e2c2a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c2a46",
  null
  
)

export default component.exports